import { render, staticRenderFns } from "./InspectionViewInspectionUntouchedFields.vue?vue&type=template&id=01bf7028"
import script from "./InspectionViewInspectionUntouchedFields.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspectionUntouchedFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports